import { defineMessages } from 'react-intl';

export const descriptionBackstageMessage = Object.freeze({
  seeAll: defineMessages({
    id: 't.seeAll',
    defaultMessage: ' See All',
  }),
});
